import {
  Box,
  Heading,
  SimpleGrid,
  GridItem,
  VStack,
  Flex,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router';

import SearchInput from '@app/components/chakra/search-input';
import { useGroupsQuery } from '@app/services/group';
import { useSubGroupsQuery } from '@app/services/subgroup';
import { Button } from '@chakra-snippets/button';

import GroupDetailView from './detail/group-detail-view';
import GroupDialog from './dialog/group-dialog';
import GroupTree from './group-tree';
import { GroupNodeData } from './helpers';

const GroupMgmt = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [selectedGroupId, setSelectedGroupId] = useState<string>('');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [uiToApiGroupIdMapping, setUiToApiGroupIdMapping] = useState(
    new Map<string, string>(),
  );
  const {
    data: groupData,
    isLoading: isLoadingGroups,
    fetchNextPage: fetchNextGroupsPage,
    hasNextPage: hasNextGroupsPage,
    isFetchingNextPage: isLoadingMoreGroups,
  } = useGroupsQuery({
    searchText,
    topLevel: searchText?.trim().length > 0 ? 'false' : 'true',
  });

  const { data: subGroupData, isLoading: isLoadingSubGroups } = useSubGroupsQuery({
    parentId: uiToApiGroupIdMapping.get(selectedGroupId) || selectedGroupId,
  });

  const groups = groupData?.pages.flatMap((page) => page.groups);
  const subgroups = subGroupData?.pages.flatMap((page) => page.groups);

  const updateIdMapping = (element: GroupNodeData) => {
    setUiToApiGroupIdMapping((prev) => {
      const updatedMapping = new Map(prev);
      updatedMapping.set(
        String(element?.id),
        element?.groupId || String(element?.id),
      );
      navigate(
        `/usermgmt/groups/${updatedMapping.get(String(element?.id)) || String(element?.id)}`,
      );
      return updatedMapping;
    });
  };

  return (
    <Box>
      <SimpleGrid columns={4} gap={8}>
        <GridItem>
          <Flex justifyContent="space-between" w="100%" marginBottom={5}>
            <Heading size="2xl">Groups</Heading>
            <GroupDialog
              isOpen={isDialogOpen}
              onOpenChange={(value) => setIsDialogOpen(value.open)}
              dialogTriggerButton={<Button>Add group</Button>}
            />
          </Flex>
          <SearchInput
            placeholder="Search groups and members"
            searchText={searchText}
            onChange={(value) => setSearchText(value)}
            showClearBtn={searchText?.length > 0}
          />
          <VStack
            align="flex-start"
            h="calc(100vh - 350px)"
            marginTop={5}
            overflowY="auto"
            overflowX="hidden"
          >
            <Box w="100%">
              <GroupTree
                groups={groups || []}
                subgroups={subgroups || []}
                setSelectedGroupId={setSelectedGroupId}
                isLoadingGroups={isLoadingGroups}
                isLoadingSubGroups={isLoadingSubGroups}
                selectedGroupId={selectedGroupId}
                increaseDataSet={fetchNextGroupsPage}
                shouldLoadMoreItems={hasNextGroupsPage}
                searchText={searchText}
                isLoadingMoreGroups={isLoadingMoreGroups}
                updateIdMapping={updateIdMapping}
                preSelectedGroupId={params?.id}
              />
            </Box>
          </VStack>
        </GridItem>
        <GridItem colSpan={3}>
          <GroupDetailView />
        </GridItem>
      </SimpleGrid>
    </Box>
  );
};

export default GroupMgmt;
